import ProtectedService from './ProtectedService';
import FileService from './FileService';

class AuditService extends ProtectedService {
  baseUrl = '/audits';

  constructor(
      public fileService: FileService,
      public getAccessToken: () => string|null,
      public setAccessToken: (token: string) => void = () => {},
      public clearAccessToken: () => void = () => {}
  ) {
    super(getAccessToken, setAccessToken, clearAccessToken);
  }

  userAudits = async (
    page: number,
    limit: number,
    sortBy?: string,
    sortDirection?: string,
    filter?: any,
  ) => this.get(
    null,
    `by-user?page=${page}&limit=${limit}${
      sortBy ? `&sort=${sortBy},${sortDirection}` : ''
    }${filter ? `&filter=${JSON.stringify(filter)}` : ''}`,
  );

  assign = async (id: number) => this.get(null, `${id}/assign`);

  unassign = async (id: number) => this.get(null, `${id}/unassign`);

  downloadText = async (id: number, filename: string) => this.fileService.downloadFile(`${this.baseUrl}/${id}/text`, filename, 'text/html');

  downloadPdf = async (id: number, filename: string) => this.fileService.downloadFile(`${this.baseUrl}/${id}/document`, filename, 'application/pdf');

  openPdf = async (id: number) => this.fileService.openFile(`${this.baseUrl}/${id}/document`);

  previewDocument = async (id: number, data: any) => this.fileService.previewDocument(
    `${this.baseUrl}/${id}/view-document`,
    data,
  );

  downloadPreview = async (id: number) => this.fileService.downloadBlob(`${this.baseUrl}/${id}/document`);

  saveAuditors = async (id: number, userIds: Array<number>) => this.post(
    {
      userIds,
    },
    `${id}/assign-auditors`,
  );

  deleteAudit = async (id: number) => this.delete(null, `${id}`);

  publishAudit = async (id: number, path: string, name: string) => this.post({
    path,
    name
  }, `${id}/publish`);

  duplicateAudit = async (id: number, name: string) => this.post(
    {
      name,
    },
    `${id}/duplicate`,
  );
}

export default AuditService;
